// Les couleurs des séries de `ChartBlock` — dans leur propre module depuis le lot B (CDC du
// 09/10) : le cadre « Comparer à » pose sur chaque puce une pastille de la couleur de SA
// série, et la pastille comme la courbe doivent sortir de la MÊME fonction, avec le MÊME
// thème (`themeGraphiques`, PR #684), pour ne jamais diverger. (Hors du fichier du
// composant : un module de composant n'exporte que des composants, sinon le rechargement à
// chaud de Vite le recharge en entier.)
import type { ChartSpec } from './ChartBlock'
import { THEME_GRAPHIQUES_SITE, type ThemeGraphiques } from './themeGraphiques'

// Couleurs officielles de l'étiquette énergie (rampe réglementaire usuelle des DPE).
export const DPE_COLORS: Record<string, string> = {
  A: '#00A651', B: '#4CB748', C: '#BFD630', D: '#FFF200',
  E: '#FDB913', F: '#F37021', G: '#ED1C24',
}

/**
 * La couleur de la série `i` (libellé `label`) telle que Chart.js la trace.
 *
 * Palette MULTI-SÉRIES (lisibilité SSMSI 16/07 : 4 lignes rendues dans LA MÊME couleur de
 * thème étaient indéchiffrables). Série 1 = couleur de la thématique ; suivantes = tons
 * distincts du thème ; toute série « strate » garde son gris conventionnel. 8 tons :
 * l'empilé 100 % de dem-4 porte 7 séries — avec 6, le 7e niveau recyclait la couleur du 1er.
 */
export function couleurSerie(label: string, i: number, couleurThematique: string,
                             palette?: ChartSpec['palette'],
                             theme: ThemeGraphiques = THEME_GRAPHIQUES_SITE): string {
  // Palette DPE officielle (T2) : la catégorie décide, pas le rang de série.
  if (palette === 'dpe' && DPE_COLORS[label]) return DPE_COLORS[label]
  if (/strate/i.test(label)) return theme.strate
  const premiere = theme.couleurTheme ? theme.couleurTheme(couleurThematique) : couleurThematique
  const tons = [premiere, ...theme.seriesSuivantes]
  return tons[i % tons.length]
}
